import { render, staticRenderFns } from "./CreatePatients.vue?vue&type=template&id=6ceb89de&scoped=true&"
import script from "./CreatePatients.vue?vue&type=script&lang=js&"
export * from "./CreatePatients.vue?vue&type=script&lang=js&"
import style0 from "./CreatePatients.vue?vue&type=style&index=0&id=6ceb89de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb89de",
  null
  
)

export default component.exports